(function employeeFileModuleDefinition() {

    'use strict';

    angular.module('EmployeeFile', ['ui.router', 'ui.tree', 'ui.treeExtend', 'ui.bootstrap.modal', 'Config', 'Entities',
                                         'ClickOnce', 'FileDownloader', 'Actions', 'TwainCapture', 'UnitOrgComboControl', 'CustomChart'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function employeeFileConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('employee-file-find', {
                    url: "/EmployeeFile/Find",
                    templateUrl: config.resourceUrl('/views/employee-file/employee-file-find.html'),
                    controller: 'EmployeeFileFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('EMPLOYEEFILE WRITE')
                                        .or('EMPLOYEEFILE READ')
                });

                $stateProvider.state('employee-file-detail', {
                    url: '/EmployeeFile/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/employee-file/detail.html'),
                    controller: 'EmployeeFileDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('EMPLOYEEFILE WRITE')
                                        .or('EMPLOYEEFILE READ')
                });

                $stateProvider.state('employee-file-edit', {
                    url: '/EmployeeFile/Edit/{id}',
                    templateUrl: config.resourceUrl('/views/employee-file/employee-file-edit.html'),
                    controller: 'EmployeeFileEditController',
                    authorize: true,
                    roles: loginProvider.roleCondition('EMPLOYEEFILE WRITE')
                });

                $stateProvider.state('employee-file-add', {
                    url: '/EmployeeFile/Add',
                    templateUrl: config.resourceUrl('/views/employee-file/employee-file-add.html'),
                    controller: 'EmployeeFileAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('EMPLOYEEFILE WRITE')
                });
            }
        ]);
})();